var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaveRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25635 11.5703C7.25635 11.018 7.70406 10.5703 8.25635 10.5703H19.0001C19.5524 10.5703 20.0001 11.018 20.0001 11.5703C20.0001 12.1226 19.5524 12.5703 19.0001 12.5703H8.25635C7.70406 12.5703 7.25635 12.1226 7.25635 11.5703Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7025 19.0083C15.246 19.0083 14.876 19.3783 14.876 19.8347V21.4876H1.65289V1.65289H14.876V3.30578C14.876 3.76222 15.246 4.13223 15.7025 4.13223C16.1589 4.13223 16.5289 3.76222 16.5289 3.30578V0.826446C16.5289 0.607259 16.4419 0.397049 16.2869 0.24206C16.1319 0.0870717 15.9217 0 15.7025 0H0.826446C0.607259 0 0.397049 0.0870717 0.242061 0.24206C0.0870719 0.397049 0 0.607259 0 0.826446V22.314C0 22.5332 0.0870719 22.7434 0.242061 22.8984C0.397049 23.0534 0.607259 23.1405 0.826446 23.1405H15.7025C15.9217 23.1405 16.1319 23.0534 16.2869 22.8984C16.4419 22.7434 16.5289 22.5332 16.5289 22.314V19.8347C16.5289 19.3783 16.1589 19.0083 15.7025 19.0083Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7072 10.8632C20.0978 11.2537 20.0978 11.8869 19.7072 12.2774L16.4014 15.5832C16.0109 15.9737 15.3778 15.9737 14.9872 15.5832C14.5967 15.1927 14.5967 14.5595 14.9872 14.169L18.293 10.8632C18.6835 10.4727 19.3167 10.4727 19.7072 10.8632Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9872 7.55754C15.3778 7.16702 16.0109 7.16702 16.4014 7.55754L19.7072 10.8633C20.0978 11.2539 20.0978 11.887 19.7072 12.2775C19.3167 12.6681 18.6835 12.6681 18.293 12.2775L14.9872 8.97176C14.5967 8.58123 14.5967 7.94807 14.9872 7.55754Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveRoom);
export default __webpack_public_path__ + "static/media/leave-room.4f8cee90430c3b6721b4c1bc9fd3dc2a.svg";
export { ForwardRef as ReactComponent };